import { render, staticRenderFns } from "./CocForm.vue?vue&type=template&id=52115604"
import script from "./CocForm.vue?vue&type=script&lang=js"
export * from "./CocForm.vue?vue&type=script&lang=js"
import style0 from "./CocForm.vue?vue&type=style&index=0&id=52115604&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VCombobox } from 'vuetify/lib/components/VCombobox';
installComponents(component, {VAutocomplete,VCombobox})
